import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/reservations';

export default {
  getAll: () => getApiUrl(`${BASE}`),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  create: () => getApiUrl(`${BASE}`),
  update: (id) => getApiUrl(`${BASE}/${id}`),
  delete: (id) => getApiUrl(`${BASE}/${id}`),
  getEligibleStatements: (id) => getApiUrl(`${BASE}/${id}/deferrals/eligible_statements`),
  defer: (id) => getApiUrl(`${BASE}/${id}/deferrals`),
};
